<template>

	<div :class="{'hide': loading}">
		<div :class="{'spinner loading': loading}"></div>

		<div class="prices">
			<div class="sidebar right">
				<div class="sidebar-item prices" style="height: 444px;">
					<p id="topic-title-form">Calculate price</p>
					<div class="cart-overview-item">
						<p class="text-header"><span>{{$qualitiesDescription[selectedQuality]}}</span> paper</p></div>
					<div class="cart-overview-item big">
						<p class="text-header"><span>{{$deadlines[selectedDeadline].substring(0, $deadlines[selectedDeadline].length - 1)}}</span> delivery</p>
					</div>

					<div class="cart-overview-item small"><p class="text-header">Pages:</p></div>
					<div class="cart-overview-item big">
						<label for="pages" class="select-block pages">
							<div id="plus-minus" class="plus-minus">
								<div id="main-pages-qty" class="contentspin clearfix">
									<input v-on:click="pagesMinus" class="buttonspin qtyminus" value="−" type="button">
									<input v-model="pages"
										   @change="calculate()"
										   class="ui-spinner"
										   name="pages" id="pages" type="text">
									<input v-on:click="pagesPlus" class="buttonspin qtyplus" value="+" type="button">
								</div>
							</div>
						</label>
					</div>
					<div v-if="$config.type !== 'white'" class="cart-overview-item small"><p class="text-header">Work type:</p></div>
					<div v-if="$config.type !== 'white'" class="cart-overview-item big">
						<select v-model="selectedType" id="type" name="type">
							<option v-for="(singleType, key) in $types" v-bind:value="key">
								{{singleType}}
							</option>
						</select>
					</div>

					<div class="cart-overview-item total-price big" style="margin-top: 20px;">
						<p class="text-header total big">Total Price:</p>
						<p class="text-header price big">
							<span class="primary">${{totalPrice}}</span></p>
					</div>

					<a :href="orderNowUrl" name="submit-button" class="button mid primary" id="call-to-action pricing">Write a paper</a>
					<div class="clearfix"></div>
				</div>
			</div>

			<div class="content left">
				<div class="price-table">
			<div class="form-box-item price-table-content">
				<table cellpadding="0" cellspacing="0">
					<thead>
					<tr id="table-head">
						<th>Urgency</th>
						<td v-for="quality in $qualities">{{quality}}</td>
					</tr>
					</thead>
					<tbody id="table-body">
					<tr v-for="(deadline, deadlineKey) in $deadlines">
						<th class="urgency-cell">{{deadline}}</th>

						<td @click.prevent="calculate(deadlineKey, qualityKey)" v-for="(quality, qualityKey) in $qualities" :class="{ active: priceHover == deadlineKey + '_' + qualityKey, selected: selectedDeadline == deadlineKey && selectedQuality == qualityKey }"
							@mouseover="priceHover = deadlineKey + '_' + qualityKey"
							@mouseout="priceHover = null">
							<div class="pricing-box">
								<!--<p class="previous-price" v-show="priceHover != deadlineKey + '_' + qualityKey">${{oldPriceCalculation(deadlineKey, qualityKey)}}</p>-->
								<a class="actual-price" href="/">${{priceCalculation(deadlineKey, qualityKey)}}</a>
							</div>
						</td>
					</tr>
					</tbody>
				</table>
			</div>
		</div>
			</div>

			<div class="clearfix"></div>

		</div>

	</div>
</template>


<script>
    import moment from 'moment';
    import pricingMixin from '../../../Mixins/pricingMixin.js';
    import plusMinusButtonsMixin from '../../../Mixins/plusMinusButtonsMixin';
    import deadlineMixin from "../../../Mixins/deadlineMixin";


    export default {
        mixins: [pricingMixin, plusMinusButtonsMixin, deadlineMixin],

        props: ['order'],
        data() {
            return {
                urgency: 2,
                isHovering: false,
                loading: true,
                priceHover: false,
                type: 1,
                pages: 2,
				pricePerPage: 0,
				totalPrice: 0,
				selectedDeadline: 4,
				selectedQuality: 3,
				selectedType: 1,
			}
        },

        created(){
            this.loading = false;
            this.calculate();

        },
        computed:{
            orderNowUrl() {
                return '/order?type='+this.selectedType+'&deadline='+this.selectedDeadline+'&quality='+this.selectedQuality+'&pages='+this.pages
			}

        },
        watch: {
            pages() {
                this.calculate();
            }

        },
        methods: {

            calculate(deadline = this.selectedDeadline, quality = this.selectedQuality){
                this.selectedDeadline = deadline;
                this.selectedQuality = quality;
                this.pricePerPage = this.priceCalculation(this.selectedDeadline, this.selectedQuality);
                this.totalPrice = this.pricePerPage * this.pages;
            }

        }

    }
</script>